import { clsx } from 'clsx';
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';

export type VarianteBotao = 'primario' | 'secundario' | 'fantasma' | 'perigo';

export interface BotaoProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBotao;
  tamanho?: 'p' | 'm' | 'g';
  icone?: ReactNode;
  carregando?: boolean;
  /** Atalho exibido ao lado do texto e no title (a tecla em si é registrada pela página). */
  atalho?: string;
}

export const Botao = forwardRef<HTMLButtonElement, BotaoProps>(function Botao(
  { variante = 'secundario', tamanho = 'm', icone, carregando, atalho, className, children, disabled, title, type = 'button', ...resto },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={clsx('botao', variante === 'primario' && 'botao-primario', variante === 'fantasma' && 'botao-fantasma',
        variante === 'perigo' && 'botao-perigo', className)}
      data-tamanho={tamanho}
      disabled={disabled || carregando}
      aria-busy={carregando || undefined}
      title={title ?? (atalho ? `${typeof children === 'string' ? children : ''} (${atalho})`.trim() : undefined)}
      aria-keyshortcuts={atalho}
      {...resto}
    >
      {icone}
      {children}
      {atalho && tamanho !== 'p' && <kbd className="atalho">{atalho}</kbd>}
    </button>
  );
});

export interface BotaoIconeProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icone: ReactNode;
  /** Obrigatório: vira aria-label e title. */
  rotulo: string;
  variante?: VarianteBotao;
}

export const BotaoIcone = forwardRef<HTMLButtonElement, BotaoIconeProps>(function BotaoIcone(
  { icone, rotulo, variante = 'fantasma', className, type = 'button', ...resto },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={rotulo}
      title={rotulo}
      className={clsx('botao botao-icone', variante === 'fantasma' && 'botao-fantasma', variante === 'primario' && 'botao-primario', className)}
      {...resto}
    >
      {icone}
    </button>
  );
});
